import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";
import { ChallengeCategory } from "./types/types";

interface PromptCardProps {
  prompt: string;
  category: ChallengeCategory;
  questionId: string;
  className?: string;
  isLoading?: boolean;
}

export function PromptCard({
  prompt,
  category,
  questionId,
  className,
  isLoading = false,
}: PromptCardProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add a small delay to trigger the animation after component mount
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={cn(
        "glass-card p-6 rounded-xl transform transition-all duration-500",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4",
        className
      )}
    >
      {/* Category tag removed as requested */}
      <h2 className="text-lg md:text-xl font-bold mb-2 font-heading">
        Today's Prompt
      </h2>
      {isLoading ? (
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      ) : (
        <p className="text-white/90 leading-relaxed">{prompt}</p>
      )}
    </div>
  );
}
